import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { TextCaption2, TextHeadline3, colors } from '@blocket/blocket-ui'

export const CardLink = styled.div`
  box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.25);
  background-color: ${colors.white100};
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  justify-content: start;
  padding: 14px;
  align-items: center;

  &:hover {
    cursor: pointer;
  }
  &:active {
    opacity: 0.75;
  }
`

export const Label = styled(TextHeadline3)`
  display: flex;
  user-select: none;
  font-size: 17px;
  margin-left: 16px;
`

const Description = styled(TextCaption2)`
  color: ${colors.black100};
  user-select: none;
  margin-left: 16px;
`

const Price = styled.div`
  margin-left: auto;
  min-width: 46px;

  > div {
    font-family: BlocketSans-Regular, sans-serif;
  }
`

const LabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

const ListCard = ({ label, description, icon, link, price, onClick }) => (
  <CardLink as="a" href={link} onClick={onClick} data-testid="list-card">
    <div>{!!icon && <span data-testid="listcard-icon">{icon}</span>}</div>
    <div style={{width: "100%"}}>
      <LabelContainer>
        <Label>{label}</Label>
        {price != null && (
          <Price style={{ alignSelf: description ? 'baseline' : 'center' }}>
            <Label>{`${price} kr`}</Label>
          </Price>
        )}
      </LabelContainer>
      {description && <Description>{description}</Description>}
    </div>
  </CardLink>
)

ListCard.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  description: PropTypes.string,
  icon: PropTypes.node,
  link: PropTypes.string,
  price: PropTypes.oneOfType([PropTypes.string,PropTypes.number]),
  onClick: PropTypes.func,
}

export default ListCard
